import "./App.css";
import Header from "./components/Header";
import RequestQuote from "./components/RequestQuote";
import Services from "./components/Services";

function App() {
  return (
    <>
      <Header />
      <RequestQuote />
      <Services />

      <footer className="footer py-4 mt-4">
        <div className="container">
          <div className="row text-white">
            <div className="col-12 d-flex justify-content-between">
              <div className="privacy">
                &copy;{new Date().getFullYear()} Thakga Events. All Rights
                Reserved.
              </div>
              <div className="social-media"></div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default App;
